import React, { createContext, useState } from "react";
const characterPlaceholderImage = require('../Images/characterPlaceholderImage.png')
export const CharacterCreatorStateContext = createContext(); 

export const CharacterCreatorStateProvider = ({ children }) => {
  const [characterCreatorState, setCharacterCreatorState] = useState({name:'', age:'', gender:'', ethnicity:'', hair:'', clothing:'', featuresToAvoid:'', characterPreview:characterPlaceholderImage, characterPreviewImageId:''})
    
  return (
    <CharacterCreatorStateContext.Provider value={{ characterCreatorState, setCharacterCreatorState }}>
      {children} 
    </CharacterCreatorStateContext.Provider>
  );
};
